module.exports = __webpack_public_path__ + "static/media/11.5e290f6a.png";